
import { ApprovalProcessStatusPolicy } from "constants/proposal/ApprovalProcessStatusPolicy";
import { EMPTY_MASTER_FSP_ENTITY } from "domain/entity/MasterFSP/MasterFSPEntity";
import _ from "lodash";
import moment from "moment";
import { MasterFSPMaintenanceConstant } from "presentation/constant/MasterFSP/MasterFSPMaintenanceConstant";
import { WorkspaceConstant } from "presentation/constant/WorkSpaceConstant";
import { useMasterFSPMaintenanceVM } from "presentation/hook/MasterFSP/useMasterFSPMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useMasterFSPMaintenanceTracked } from "presentation/store/MasterFSP/MasterFSPMaintenanceProvider";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { memo, useCallback, useEffect, useState } from "react";
import { HPHButton, IconButton, Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import { Sidebarheader, StyledAction } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
import MasterFSPSearchPanel from "./Left/MasterFSPSearchPanel";
import MasterFSPRejectReasonModal from "./MasterFSPRejectReasonModal";
import MasterFSPTablePanel from "./MasterFSPTablePanel";
import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { isPermissionExist } from "presentation/utils/permissionUtils";
import { AclType } from "presentation/constant/ANAInfo/NbisivPermission";

const MasterFSPMaintenance: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [masterFSPState] = useMasterFSPMaintenanceTracked();
    const masterFSPVM = useMasterFSPMaintenanceVM();
    const { isBackMaster, selectedRows, searchStatus, isShowCriteriaPanel, searchCriteria, isAllowAutoSearch } = masterFSPState;
    const messageBarVM = useMessageBarVM();
    const [anainfoState] = useANAInfoTracked();
    // const { allowUpdate } = anainfoState;

    const isUpdateSubmit = isPermissionExist(Permission.MASTER_FSP_SUBMIT, AclType.UPDATE, anainfoState.defaultOperatingCompany, anainfoState.allNbisivPermission);
    const isUpdateReject = isPermissionExist(Permission.MASTER_FSP_REJECT, AclType.UPDATE, anainfoState.defaultOperatingCompany, anainfoState.allNbisivPermission);
    const isUpdateApprove = isPermissionExist(Permission.MASTER_FSP_APPROVE, AclType.UPDATE, anainfoState.defaultOperatingCompany, anainfoState.allNbisivPermission);

    useEffect(() => {
        const initialScreen = async () => {
            setIsLoading(true);
            try {
                const results = await Promise.allSettled([
                    masterFSPVM.onCountRejectedPendingApproval(),
                    masterFSPVM.loadDropdownOption(anainfoState.operatingUnit),
                ]);
                results?.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {

                    }
                })
                if (searchStatus === "") {
                    let newSearchCriteria = null;
                    if (isBackMaster) {
                        newSearchCriteria = { ...searchCriteria };
                    } else {
                        newSearchCriteria = { ...EMPTY_MASTER_FSP_ENTITY }
                        newSearchCriteria = {
                            ...newSearchCriteria,
                            effectiveDateFrom: moment().subtract(2, "years").startOf("year").toDate(),
                            effectiveDateTo: moment().endOf('year').endOf('day').toDate(),
                        };
                    }
                    const standardResults = await Promise.allSettled([
                        masterFSPVM.searchMasterFSP(newSearchCriteria),
                    ]);
                    standardResults?.forEach((result, index) => {
                        if (index === 0 && result.status === 'fulfilled') {

                        }
                    })
                } else {
                    const groupButtonResults = await Promise.allSettled([
                        masterFSPVM.onGroupButtonClick(searchStatus),
                    ]);
                    groupButtonResults?.forEach((result, index) => {
                        if (index === 0 && result.status === 'fulfilled') {

                        }
                    })
                }
            } catch (error) {
                setIsLoading(false);
            }
        }
        isAllowAutoSearch && initialScreen().then(() => {
            setIsLoading(false)
        }).catch(error => {
            setIsLoading(false)
        });

    }, [isAllowAutoSearch, isBackMaster, masterFSPVM, searchStatus, searchCriteria, anainfoState.operatingUnit])

    const handleSearch = useCallback(() => {
        masterFSPVM.onSearchClick();
    }, [masterFSPVM]);

    const handleSubmit = useCallback(() => {
        if (!selectedRows || _.isEmpty(selectedRows)) {
            messageBarVM.showError('Please select a record.')
            return;
        }
        if (selectedRows?.some(row => row.status === ApprovalProcessStatusPolicy.STATUS_FINALIZED)) {
            messageBarVM.showError('Please select NEW / PROPOSED status to submit.')
            return;
        }
        setIsLoading(true);
        masterFSPVM.onSubmit(selectedRows).then((res) => {
            if (res && !res.success) {
                messageBarVM.showError(res.data as string)
            }
            masterFSPVM.searchMasterFSP(masterFSPState.searchCriteria).then(() => {
                setIsLoading(false)
                messageBarVM.showSuccess("Submit successfully.");
            }).catch((error) => {
                setIsLoading(false)
            })
        }).catch((error) => {
            setIsLoading(false)

        });

    }, [selectedRows, messageBarVM, masterFSPVM, masterFSPState.searchCriteria]);

    const handleReject = useCallback(async () => {
        if (selectedRows.length !== 1) {
            messageBarVM.showError("Please select a record.");
            return;
        }
        if (!selectedRows.every(entity => entity.status === "FINALIZED")) {
            messageBarVM.showError("The selected proposal is not in \"FINALIZED\" state.");
            return;
        }
        masterFSPVM.onRejectClick(selectedRows[0]);
    }, [messageBarVM, selectedRows, masterFSPVM]);


    const handleApprove = useCallback(async () => {
        if (selectedRows.length === 0) {
            messageBarVM.showError("Please select a record.");
            return;
        }
        if (!selectedRows.every(entity => entity.status === "FINALIZED")) {
            messageBarVM.showError("The selected proposal is not in \"FINALIZED\" state.");
            return;
        }
        setIsLoading(true)
        masterFSPVM.onApprove(selectedRows).then(async (data) => {
            if (data.success) {
                messageBarVM.showSuccess("Approve successfully.");
                if (searchStatus !== "") {
                    masterFSPVM.onGroupButtonClick(searchStatus);
                } else {
                    masterFSPVM.searchMasterFSP(masterFSPState.searchCriteria);
                }
            } else {
                data.msg && messageBarVM.showError(data.msg);
            }
            setIsLoading(false)
        }).catch(error => {
            setIsLoading(false)
        });
    }, [messageBarVM, searchStatus, selectedRows, masterFSPVM, masterFSPState.searchCriteria]);

    const isSubmitDisable = () => {
        if (selectedRows && selectedRows.length > 0
            && selectedRows?.every(entity =>
                "FINALIZED" !== entity.status && !entity.confirmedDate)
        ) return false;

        return true;
    }

    const isRejAndAppDisable = () => {
        if (/*isPendingApproval &&*/ selectedRows && selectedRows.length > 0
            && selectedRows?.every(entity =>
                "NEW" !== entity.status && !entity.confirmedDate)
        ) return false;

        return true;
    }

    return <>
        {isLoading && <Loader Indicator="Stripe" size="Medium" />}
        <div className={`main-comp-wrapper${isShowCriteriaPanel ? '' : ' im-hide-side-form-draggable'}`}>
            <Sidebarheader style={{ width: '100%', display: "flex", alignItems: "center" }}>
                <HeaderTitle>{MasterFSPMaintenanceConstant.TITLE}</HeaderTitle>
                <StyledAction className="tm-animated-wrapper">
                    <IconButton fileName='Icon-search' size='medium' toolTipText={'Search'} toolTipArrow={false} onClick={handleSearch} />
                    <div className="add-seperator" />
                    {(isUpdateSubmit) && <HPHButton label={WorkspaceConstant.Common.BUTTON_SUBMIT} disabled={isSubmitDisable()} size={'Small'} theme={'Secondary'} onClick={handleSubmit} />}
                    {(isUpdateReject) && <HPHButton label={WorkspaceConstant.Common.BUTTON_REJECT} disabled={isRejAndAppDisable()} size={'Small'} theme={'Secondary'} onClick={handleReject} />}
                    {(isUpdateApprove) && <HPHButton label={WorkspaceConstant.Common.BUTTON_APPROVE} disabled={isRejAndAppDisable()} size={'Small'} theme={'Primary'} onClick={handleApprove} />}
                </StyledAction>
            </Sidebarheader>
            <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={isShowCriteriaPanel ? "25%" : "0%"}
                rightSectionWidth={isShowCriteriaPanel ? "75%" : "100%"}
                leftChildren={<MasterFSPSearchPanel />}
                rightChildren={<MasterFSPTablePanel />}
            />
            <div className='im-charge-data-search-confirm-modal-container'>
                {<MasterFSPRejectReasonModal />}
            </div>
            {masterFSPState.forceRefresh && <></>}
        </div>
    </>
}

export default memo(MasterFSPMaintenance);